import * as React from 'react'
import cx from 'classnames'
import styles from './input.module.css'
import InputMask from 'react-input-mask'

export type Props = {
  /** The `name` is also used for id and htmlFor */
  name: string
  /** Label  */
  label?: string
  /** Placeholder must be not empty */
  placeholder?: string
  /** [imask doc](https://imask.js.org/) */
  mask?: string | Array<string | RegExp>
  /** Right dock */
  rightDock?: string | React.ReactNode
  /** class */
  className?: string
  /** label style */
  labelStyle?: React.CSSProperties
  /** handle method of clsadasdsad */
  onClick?: React.FormEventHandler<HTMLElement>
}

/** Input component with mask and floating label */
const Input: React.FC<Props> = ({
  name,
  label,
  placeholder,
  mask,
  rightDock,
  className,
  labelStyle,
  onClick,
  ...props
}) => {
  return (
    <div className={cx(styles.container, className)}>
      <InputMask
        id={name}
        name={name}
        type="text"
        placeholder={placeholder || ' '}
        mask={mask}
        className={cx(styles.input)}
        autoComplete="off"
        onClick={onClick}
        {...props}
      />
      <label htmlFor={name} className={cx(styles.label)} style={labelStyle}>
        {label}
      </label>
      {rightDock && <span className={styles.rightDock}>{rightDock}</span>}
    </div>
  )
}

export { Input }
